// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General layout */
.page-container {
    /* max-width: 960px; */
    margin: 0 auto;
    padding: 2rem 15%;
    background-color: var(--secondary-light);
  }
  
  /* Page title */
  .page-title {
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
  }
  
  /* Paragraphs */
  .page-text {
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 1rem;
  }
  
  /* Bullet list */
  .page-list {
    list-style: disc inside;
    margin-bottom: 2rem;
    padding-left: 1rem;
  }
  
  .page-list li {
    margin-bottom: 1rem;
  }
  
  /* Responsive typography */
  @media (min-width: 768px) {
    .page-title {
      font-size: 2.5rem;
    }
  
    .page-text {
      font-size: 1.125rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/weather.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,wCAAwC;EAC1C;;EAEA,eAAe;EACf;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA,eAAe;EACf;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,gBAAgB;EAChB;IACE,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,0BAA0B;EAC1B;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,mBAAmB;IACrB;EACF","sourcesContent":["/* General layout */\n.page-container {\n    /* max-width: 960px; */\n    margin: 0 auto;\n    padding: 2rem 15%;\n    background-color: var(--secondary-light);\n  }\n  \n  /* Page title */\n  .page-title {\n    font-size: 2rem;\n    font-weight: 600;\n    margin-bottom: 1.5rem;\n  }\n  \n  /* Paragraphs */\n  .page-text {\n    font-size: 1rem;\n    line-height: 1.6;\n    margin-bottom: 1rem;\n  }\n  \n  /* Bullet list */\n  .page-list {\n    list-style: disc inside;\n    margin-bottom: 2rem;\n    padding-left: 1rem;\n  }\n  \n  .page-list li {\n    margin-bottom: 1rem;\n  }\n  \n  /* Responsive typography */\n  @media (min-width: 768px) {\n    .page-title {\n      font-size: 2.5rem;\n    }\n  \n    .page-text {\n      font-size: 1.125rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
